import { Login } from "./Componets/Login";
import { reducerCases } from "./utlis/Contants";
import { useEffect } from "react";
import { useStateProvider } from "./utlis/StateProvider";
import { Spotify } from "./Componets/Spotify";
function App() {
  const [{ token }, dispatch] = useStateProvider();

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const token = hash.substring(1).split("&")[0].split("=")[1];

      dispatch({ type: reducerCases.SET_TOKEN, token });
    }
  }, [token, dispatch]);

  return <div>{token ? <Spotify /> : <Login />}</div>;
}

export default App;
